import axios, { AxiosRequestConfig, AxiosError } from 'axios';
import MockAdapter from 'axios-mock-adapter';

interface ApiPoint {
  url: string;
  baseUrl?: string
  method?: 'get' | 'post';
  mockData?: {
    status: 200 | 500
    response: Record<string, any>
  }
}
export interface ApiConfig {
  baseUrl?: string;
  entry: {
    getUser?: ApiPoint;
    create?: ApiPoint;
    update?: ApiPoint;
    validation?: ApiPoint;
    finish?: ApiPoint;
    // [name: string]: {
    //   url: string;
    //   baseUrl?: string
    //   method?: 'get' | 'post';
    //   mockData?: {
    //     status: 200 | 500
    //     response: Record<string, any>
    //   }
    // };
  };
}

interface ApiFunctions {
  [name: string]: (config?: AxiosRequestConfig) => Promise<any>;
}

interface ApiFactory {
  apiConfig: ApiConfig;
  abTest?: string;
  isTest?: boolean;
}

function createApiFunctions({
  apiConfig, 
  abTest = 'a', 
  isTest = false
}: ApiFactory): ApiFunctions {
  // console.log('createApiFunctions', process?.env?.REACT_APP_TEST)
  const apiFunctions: ApiFunctions = {};

  for (const [name, entry] of Object.entries(apiConfig.entry)) {
    const { url, method = 'post', baseUrl, mockData } = entry;

    let fullUrl = url;

    if (apiConfig?.baseUrl) {
      fullUrl = `${apiConfig.baseUrl}${url}`;
    }
   
    if (baseUrl) {
      fullUrl = `${baseUrl}${url}`
    }
    // console.log(process?.env?.REACT_APP_AB_TEST)
    // const abTest = process?.env?.REACT_APP_AB_TEST || 'a'

    const axiosConfig: AxiosRequestConfig = {
      method,
      url: fullUrl,
      headers: {
        'Content-Type': 'application/json',
        'ab': abTest
      }
    };
    console.log(abTest)

    let axiosInstance = axios;
  //@ts-ignore
    apiFunctions[name] = async (data: any, lff_uid: string) => {
      console.log('apiFunctions', 'isTest =>', isTest)
      if (isTest) {
        const mockAdapter = new MockAdapter(axios);
        // const mockData = mock[name];
        if (mockData) {
          mockAdapter.onAny(fullUrl).reply(mockData.status, mockData.response);
        } else {
          mockAdapter.onAny(fullUrl).reply(200);
        }
        //@ts-ignore
        axiosInstance = axios.create({ adapter: mockAdapter.adapter() });
      }
      if (lff_uid) {
        //@ts-ignore
        axiosConfig.params = {lff_uid: lff_uid}
      }
      try {
        const response = await axiosInstance({ data, ...axiosConfig });
        return response.data;
      } catch (error) {
        const axiosError = error as AxiosError;
        const errorMessage = axiosError?.message || 'An error occurred';
        return { status: false, errorMessage };
      }
    }
  }

  return apiFunctions;
}

export default createApiFunctions